<template>
  <div>
    <b-form-checkbox
      class="switch-item"
      v-model="mdoelStatus"
      @change="SendChange"
      :disabled="isDisabled"
      switch
    >
      {{ text }}
    </b-form-checkbox>
  </div>
</template>
<script>
/* eslint:disable */
export default {
  name: "SwitchItem",
  props: ["text", "status", "isDisabled"],
  data() {
    return {
      mdoelStatus: this.status,
    };
  },

  watch:{
    mdoelStatus(value){
      // eslint-disable-next-line
      this.status = value;
    }
  },

  methods: {
    SendChange() {
      this.$emit("getStatus", !this.status);
    },
  },
};
</script>

<style scoped>
</style>